import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/custom.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.min.css'
import { animate } from 'animate.css'
import { createPinia } from 'pinia'


import InstagramFeed from "vue3-instagram-feed";
// import "vue3-instagram-feed/dist/style.css";

// Criar head
import { createHead } from '@vueuse/head'

const app = createApp(App)
const head = createHead()

app.use(head)

app.config.globalProperties.$site = process.env.VUE_APP_site
app.config.globalProperties.$api_link = process.env.VUE_APP_api

app.use(createPinia())
// app.use(animate)
app.use(router)
app.use(InstagramFeed)
app.mount('#app')

// createApp(App)
//   .use(animate)
//   .use(router)
//   .mount('#app')
